import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "19",
  fill: "none",
  viewBox: "0 0 18 19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M5.25 16.613q-.619 0-1.059-.44a1.45 1.45 0 0 1-.441-1.06q0-.618.441-1.059t1.059-.44 1.06.44q.44.44.44 1.06 0 .618-.44 1.059a1.44 1.44 0 0 1-1.06.44m7.5 0q-.618 0-1.059-.44a1.45 1.45 0 0 1-.441-1.06q0-.618.441-1.059t1.059-.44q.619 0 1.06.44.44.44.44 1.06 0 .618-.44 1.059a1.44 1.44 0 0 1-1.06.44m-8.137-12 1.8 3.75h5.25l2.062-3.75zm-.713-1.5h11.063q.43 0 .656.385.225.385.018.778l-2.662 4.8q-.206.375-.553.581a1.46 1.46 0 0 1-.76.206H6.076l-.825 1.5h8.25q.319 0 .535.216a.72.72 0 0 1 .215.534q0 .32-.216.535a.72.72 0 0 1-.534.215H5.25q-.843 0-1.275-.74t-.038-1.472L4.95 8.813l-2.7-5.7H1.5a.72.72 0 0 1-.534-.216.73.73 0 0 1-.216-.534q0-.318.216-.534a.73.73 0 0 1 .534-.216h1.219q.205 0 .393.113a.7.7 0 0 1 .282.319z"
    }, null, -1)
  ]))]))
}
export default { render: render }